import React, { useState } from "react";
import "./Roofrepair.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';
import Adsense from "../Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import InArticleAd from "../InArticleAd"; // 🔥 ייבוא המודעה החדשה לגוף המאמר

export default function Waterproofingroofswithbituminoussheets() {



  return (

    <div className="Roofrepair-page">
      <div className="Roofrepair-hero">
        <div className="Roofrepair-overlay">
          <h1>   איטום גגות ביריעות ביטומניות</h1>
        </div>
<div>
</div>
</div>
    <div className="page3">
 <div className="breadcrumb3">
  <Link to="/">בית</Link> /{" "}
  <Link to="/ProfessionalInformation"> מידע מקצועי</Link>/{" "}
   <Link to="/Bituminoussheets">   יריעות ביטומניות</Link>/{" "}
    <Link to="/Waterproofingroofswithbituminoussheets">   איטום גגות ביריעות ביטומניות</Link>{" "}
</div>
    </div>

      {/* CONTENT */}
<div className="page4">
  <div className="container">

    <h2 className="top-text">
בעבר, היה איטום הגגות, נעשה אך ורק באמצעות זפת. כיום, סוג האיטום העיקרי בו משתמשים לגגות, הן יריעות איטום ביטומניות. איטום גגות ביריעות ביטומניות, נעשה בעיקר על ידי יריעות של חברת "ביטום". במאמר זה, נלמד על איטום ביריעות ביטומניות. נכיר את סוגי יריעות האיטום הנפוצות, נלמד על היתרונות של איטום ביריעות על פני מריחת חומר איטום, ועל יריעות העמידות בפני חדירת שורשים.
    </h2>



   <h2 className="main-title">
מה היתרון של איטום גגות ביריעות ביטומניות מאשר במריחת חומר איטום?
    </h2>
    <div className="content-row">

      <div className="image-box">
        <img src="/images/60.jpg" alt="roof" />
      </div>
      <div className="text-box">
        <p> מדוע בעלי בניינים רבים, מעדיפים לבצע איטום גגות  ביריעות ביטומניות, מאשר לאטום באמצעות מריחת חומר איטום? אין ספק, שחומרי האיטום למריחה הינם יעילים. אולם, יריעות האיטום נותנות הגנה יותר מרבית. היריעות, עמידות וחזקות, ומונעות חלחול של מי הגשמים. מי הגשמים אינם יכולים לחדור את היריעות. מי הגשמים יוצרים שלולית על היריעות, ומתנקזים אל צינור הניקוז של הבניין, או אל בור הביוב של החצר. יריעות האיטום יכולים להחזיק מעמד לפחות לכמה שנים. לעומת זאת, חומר איטום למריחה, יחזיק מעמד פחות זמן. חומר שעשוי ממשחה ולא מיריעה, יכול פחות למנוע חדירה של מי גשם.</p>
      </div>

    </div>

    <h2 className="main-title">
מומלץ לבחור ביריעות איטום המכילות פולימרים:

    </h2>

    <div className="bottom-text">
      <p>יריעות האיטום המשובחות ביותר, הן יריעות איטום ביטומניות, המכילות פולימרים. ישנם 2 סוגי יריעות ביטומניות, המכילות פולימרים: 1. יריעות איטום המכילות פולימר APP, ויריעות איטום המכילות פולימר .SBS יריעות המכילות פולימר SBS, הינן גמישות מאוד.  יריעות המכילות פולימר APP, מתאימות לאיטום על גגות. יריעות המכילות פולימר SBS, מתאימות לאיטום רצפה, חניון, וקירות. היריעות מגיעות בגוונים לבן ושחור.</p>

    <h2 className="main-title">
ישנן 2 צבעים עיקריים ליריעות איטום ביטומניות:

    </h2>

      <p>ישנן 2 סוגי יריעות איטום ביטומניות בצבעים שונים: סוג אחד הן יריעות לבנות, וסוג אחר הן יריעות שחורות. איטום גגות ביריעות איטום ביטומניות, נעשה באמצעות יריעות לבנות. הצבע הלבן, עמיד בפני השמש. לעומת זאת, איטום חצרות ומרתפים, נעשה באמצעות יריעות שחורות. הצבע השחור, עמיד פחות בפני השמש. 2 סוגי היריעות נותנות לנו איטום איכותי. </p>

            <p>
</p>

    <h2 className="main-title">
איטום גגות ביריעות ביטומניות המונעות חדירת שורשים:

    </h2>
      <p>  פעמים רבות, רטיבות נוצרת כתוצאה מחדירת שורשים. למשל: בחצרות בתים, שורשי העצים יסדקו את האדמה, ויחדרו אל בור הביוב. בחורף- עלולה להיווצר מכך הצפה. לכן, פותחו יריעות איטום ביטומניות, המיועדות נגד חדירת שורשים. לכן, בחניות או בחצרות בהן מתבצע איטום ביריעות ביטומניות, ויש חשש ששורשים יחדרו וייסדקו את היריעות, מומלץ להשתמש ביריעות המיוחדות העמידות בפני שורשים. </p>

    </div>


     <ContactSection2/>
<div className="links">

  <Link to="/Bituminoussheets" className="link-right" >יריעות ביטומניות</Link>
  <Link to="/Roofwaterproofingsheets" className="link-left" >יריעות איטום לגג  </Link>

</div>

      </div>
    </div>
  

      </div>
  );
}

